import {
  REGISTER_FETCH_ENTITY,
  SET_FETCH_ENTITY_RESPONSE,
  SET_FETCH_ENTITY_LOADING,
  SET_FETCH_ENTITY_ERROR,
} from '../constants/fetch';

const initialState = {
  id: null,
  response: [],
  loading: false,
  error: null,
};

function resolve(state = initialState, action) {
  switch (action.type) {
    case SET_FETCH_ENTITY_RESPONSE:
      return Object.assign({}, state, { response: action.payload.response });
    case SET_FETCH_ENTITY_LOADING:
      return Object.assign({}, state, { loading: action.payload.loading });
    case SET_FETCH_ENTITY_ERROR:
      return Object.assign({}, state, { error: action.payload.error });
    default:
      return state;
  }
}

export default function fetchReducer(state = {}, action) {
  const { type, payload } = action;
  switch (type) {
    case REGISTER_FETCH_ENTITY:
      return Object.assign({}, state, {
        [payload.id]: { ...payload.options, isInit: true },
      });
    case SET_FETCH_ENTITY_LOADING:
    case SET_FETCH_ENTITY_ERROR:
    case SET_FETCH_ENTITY_RESPONSE:
      return Object.assign({}, state, {
        [payload.id]: resolve(state[payload.id], action),
      });
    default:
      return state;
  }
}
